// #GR71 — client mirror of the server normalizeFontStack (netlify/functions/_lib/validation.ts).
// The Brand-kit editor's role-font inputs normalize on blur so a malformed stack (unquoted
// multi-word family, trailing space, no generic fallback — David's "its battilgo ") is healed
// immediately and the specimen preview follows it — matching exactly what the server writes at
// lock. Keep in LOCKSTEP with the server copy; test/font-stack.test.ts asserts the two agree.
// (Established pattern here: a client lib mirrors a server pure helper — cf. clientTokens.ts,
// previewUrl.ts — because netlify functions never import from src/ and the client doesn't
// bundle zod.)

const GENERIC_FAMILIES = new Set([
  'serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui',
  'ui-serif', 'ui-sans-serif', 'ui-monospace', 'ui-rounded', 'math', 'emoji', 'fangsong',
]);
const BARE_IDENT_RE = /^-?[A-Za-z_][A-Za-z0-9_-]*$/;

export function normalizeFontStack(raw: string): string {
  if (typeof raw !== 'string') return raw;
  const tokens = raw.split(',').map((t) => t.trim()).filter((t) => t.length > 0);
  if (tokens.length === 0) return raw.trim();
  let hasGeneric = false;
  const out = tokens.map((tok) => {
    const lower = tok.toLowerCase();
    if (GENERIC_FAMILIES.has(lower)) {
      hasGeneric = true;
      return lower;
    }
    if ((tok.startsWith("'") && tok.endsWith("'")) || (tok.startsWith('"') && tok.endsWith('"'))) return tok;
    if (BARE_IDENT_RE.test(tok)) return tok;
    return `'${tok.replace(/['"]/g, '')}'`;
  });
  if (!hasGeneric) out.push('sans-serif');
  return out.join(', ');
}
